<div class="div__container">
  <p class="p__descriptionText">
    {{ 'NOT_FOUND.SUGGEST_PRODUCT' | translate }}
  </p>
  <button class="btn__requestProduct" (click)="openRequestProductDialog()">
    {{ 'NOT_FOUND.SUGGEST_A_PRODUCT' | translate }}
  </button>
</div>
